import { Grid, Typography } from '@rbx/ui';
import React, { FunctionComponent, Fragment } from 'react';
import { useTranslation } from '@rbx/intl';
import type { OpenCloudAPISchema } from '../../../utils/oasTypes';
import OpenCloudType from './OpenCloudType';
import { consonantTypes, vowelTypes } from '../constants/SchemaObjectTypes';
import useSchemaDescriptionStyles from './SchemaDescription.styles';

interface SchemaDescriptionProps {
  schema: NonNullable<OpenCloudAPISchema>;
  section: 'requestBody' | 'responses';
  className?: string;
}

const SchemaDescription: FunctionComponent<React.PropsWithChildren<SchemaDescriptionProps>> = ({
  className,
  schema,
  section,
}) => {
  const {
    classes: { descriptionContainer },

    cx,
  } = useSchemaDescriptionStyles();

  const { translate } = useTranslation();

  if (!('type' in schema && schema.type)) {
    return null;
  }

  let label = '';
  switch (section) {
    case 'requestBody': {
      if (consonantTypes.has(schema.type)) {
        label = 'Label.RequestBodyA';
      } else if (vowelTypes.has(schema.type)) {
        label = 'Label.RequestBodyAn';
      } else {
        throw new Error(`Schema description received unexpected type: ${schema.type}`);
      }
      break;
    }
    case 'responses': {
      if (consonantTypes.has(schema.type)) {
        label = 'Label.ReturnsA';
      } else if (vowelTypes.has(schema.type)) {
        label = 'Label.ReturnsAn';
      } else {
        throw new Error(`Schema description received unexpected type: ${schema.type}`);
      }
      break;
    }
    default:
      throw new Error(`Unexpected value of section prop: ${section}`);
  }

  return (
    <Grid container direction='column' className={cx(descriptionContainer, className)}>
      <Typography>
        {translate(label)} <OpenCloudType schema={schema} />
        {'enum' in schema && (
          <Fragment>
            {' '}
            {/** Not translating "enum" - maybe this will be a link */}
            (enum):{' '}
            <Typography variant='code' display='inline'>
              {schema.enum?.map((enumObj) => `"${enumObj}"`).join(', ')}
            </Typography>
          </Fragment>
        )}
      </Typography>
    </Grid>
  );
};

export default SchemaDescription;
